// 3.A.5 (vaihe 3.A): pieni badge nayttaakseen miten projekti syntyi DB:hen.
// Käyttäjän visuaalinen vihje siitä, mistä projekti tuli — vai luotu käsin
// vai automaattinen tunnistus jostain konventiosta.

export type DiscoveredVia = "manual" | "sidecar" | "convention" | "vault";

const LABELS: Record<DiscoveredVia, { label: string; tone: string }> = {
  manual: {
    label: "Manuaali",
    tone: "bg-slate-700 text-slate-300",
  },
  sidecar: {
    label: "Sidecar",
    tone: "bg-cyan-900/40 text-cyan-300",
  },
  convention: {
    label: "Konventio",
    tone: "bg-purple-900/40 text-purple-300",
  },
  vault: {
    label: "ProjectVault",
    tone: "bg-emerald-900/40 text-emerald-300",
  },
};

export function ProjectDiscoveryBadge({
  discoveredVia,
}: {
  discoveredVia: DiscoveredVia | null | undefined;
}) {
  const via = discoveredVia ?? "manual";
  const { label, tone } = LABELS[via] ?? LABELS.manual;
  return (
    <span
      className={`rounded px-1.5 py-0.5 text-[10px] uppercase tracking-wide ${tone}`}
      title={`Projekti tunnistettu: ${label}`}
    >
      {label}
    </span>
  );
}
